import * as React from "react";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { Organisation } from "../../../../../../Wrap/Models/Models/Customer/Organisation";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { WizardComponent } from "../../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../../Resoures/Contents";
import { Urls } from "../../../../Urls";
import { ClientRecordAction } from "../Action/ClientRecordAction";
import { AddTrustMemberAction } from "../AddTrustMember/Action/AddTrustMemberAction";
import { ClientRecordTab } from "../Resource/Contents";
import { ClientRecordStore } from "../Store/Variable";
import { AddBeneficiaries } from "./Component/AddBeneficiary";

export class AddBeneficiaryWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(ClientRecordStore, () => this.onStoreChange());
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {}

    private onStoreChange() {
        const data = ClientRecordStore.getData();
        if (!CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
            const organisation = JSON.parse(JSON.stringify(data[ClientRecordTab.OrganisationDetails]));
            (organisation as Organisation).Beneficiaries = [];
            (organisation as Organisation).OrganisationMembers = [];
            this.setState({ data: { Organisation: organisation }, isLoading: false });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const id = getQueryParameters()["customerid"];
        ClientRecordAction.getOrganisationDetail(id);
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        Navigator.navigateTo(
            Urls.get().main.PortfolioDashboard({
                hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, params["customerid"]),
            }).TrustServicing
        );
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, onPosting: true });
        AddTrustMemberAction.addTrustMembers(this.state.data?.Organisation, (data) => {
            this.setState({ isSubmitting: false, active: true, onPosting: false });
            this.onExit();
        });
    }

    setStepperConfig() {
        this.stepperConfig = [
            {
                title: "Add additional beneficiaries",
                url: Urls.get().AddBeneficiary,
                path: Contents.URLMap.beneficiary,
                canSubmit: () => this.child[0].isValid(),
                onSubmit: () => this.onSubmit(),
                component: <AddBeneficiaries {...this.getStepProps(0)} />,
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Add additional beneficiaries";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        processProps.needSplitHeader = null;
        return processProps;
    }
}
